"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StoringPlacesCell = function StoringPlacesCell(_ref) {
  var storingPlaces = _ref.cellData;

  if (storingPlaces) {
    return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedNumber, {
      value: storingPlaces,
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      useGrouping: false
    }));
  }

  return null;
};

StoringPlacesCell.propTypes = {
  cellData: _propTypes["default"].number
};
StoringPlacesCell.defaultProps = {
  cellData: null
};
var _default = StoringPlacesCell;
exports["default"] = _default;